/** A form's submission: pending while it runs, and the message of why it was refused. */
import { useState } from 'react'

export function useSubmission(failedMessage: string) {
  const [pending, setPending] = useState(false)
  const [error, setError] = useState<string | null>(null)

  /** Runs ``submit`` (null once done, else the refusal's message); true when it went through. */
  const run = async (submit: () => Promise<string | null>): Promise<boolean> => {
    setPending(true)
    setError(null)
    let refusal: string | null
    try {
      refusal = await submit()
    } catch {
      refusal = failedMessage
    }
    setPending(false)
    setError(refusal)
    return refusal === null
  }

  return { pending, error, run, clearError: () => setError(null) }
}
